import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import type { OnlineShareChannel } from 'src/app/pages/starterDashboard/shared/types';
import type { ShareAction } from 'src/app/shared/hooks/share';

import { ActionItems } from './components/ActionItems';
import { useTrackShareActionsView } from './hooks/useTrackShareActionsView';

type OnlineShareAction = ShareAction<OnlineShareChannel>;

export const useSharePetitionModal = createModalHook<{ actions: readonly OnlineShareAction[]; petitionId: string }>({
	name: 'SharePetitionModal',
	heading: () => (
		<Heading as="h1" size="h3">
			<Translate value="corgi.petition.starter_dashboard.grow_petition.share_modal.title" />
		</Heading>
	),
	body: function SharePetitionModal({ options: { actions, petitionId } }) {
		const channels = actions.map((action) => action.channel);

		useTrackShareActionsView({ channels, petitionId });

		return (
			<Box mt={16}>
				<Text>
					<Translate value="corgi.petition.starter_dashboard.grow_petition.share_modal.call_to_action" />
				</Text>
				<ActionItems actions={actions} />
			</Box>
		);
	},
});
